import { render, staticRenderFns } from "./ProductPanel.vue?vue&type=template&id=03361d24&"
import script from "./ProductPanel.vue?vue&type=script&lang=ts&"
export * from "./ProductPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports